import faTag from "icons/regular/tag.svg";
import faExclamationTriangle from "icons/regular/triangle-exclamation.svg";
import faSmile from "icons/regular/face-smile.svg";
import faBookHeart from "icons/regular/book-heart.svg";
import faQuestionCircle from "icons/regular/circle-question.svg";

import { TagCategoryType } from "types/TagType";

export const categoryMap: TagCategoryType[] = [
  {
    category: "Genre",
    icon: faBookHeart,
  },
  {
    category: "Mood",
    icon: faSmile,
  },
  {
    category: "Content Warning",
    icon: faExclamationTriangle,
  },
  {
    category: "Tag",
    icon: faTag,
  },
];

export const categoryIconMap = {
  Genre: faBookHeart,
  Mood: faSmile,
  "Content Warning": faExclamationTriangle,
  Tag: faTag,
};

export const unknownCategoryIcon = faQuestionCircle;

export const allCategories = Object.keys(categoryIconMap);

export const defaultCategories = {
  Genre: [],
  Mood: [],
  "Content Warning": [],
  Tag: [],
};

export const categoryColorMap = {
  Genre: "bg-secondary border border-muted",
  Mood: "bg-green-800 border border-green-700 text-white",
  "Content Warning": "bg-accent text-accent-foreground border border-accent",
  Tag: "bg-secondary text-secondary-foreground border border-secondary ",
};
export const categoryHoverColorMap = {
  Genre: "hover:bg-primary hover:border-primary hover:text-primary-foreground",
  Mood: "hover:bg-green-900",
  "Content Warning": "hover:bg-yellow-500",
  Tag: "hover:bg-gray-800",
};
